<template>
  <div id="app" class="d-flex flex-column h-100">
    <signature />
    <nav-bar />
    <div class="outer">
      <error />
      <div>
        <router-view />
      </div>
    </div>
    <Footer class="footer text-center"></Footer>
  </div>
</template>

<script>
import Signature from "./components/Signature";
import NavBar from "./components/NavBar";
import Error from "./components/Error";
import Footer from "./components/Footer";
export default {
  components: {
    Signature,
    NavBar,
    Error,
    Footer
  }
};
</script>
